import defaultState from './state'
import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

/** Cards State Vuex module */
export default {
  namespaced: true,
  state: { ...defaultState },
  actions,
  getters,
  mutations
}
